import React, { useRef, useState } from "react";
import { useDispatch } from "react-redux";
// import { useNavigate } from "react-router-dom";
import {
  DownArrowIcon,
  AccountSettingsIcon,
  // SupportIcon,
  LogoutIcon,
} from "../../common/Icons";
import "./Header.css"; // Import your CSS file
import Menu from "../../common/Menu";
import { logoutAction } from "../../../redux/actions/authActions";
import FullScreenOverlay from "../../common/FullScreenOverlay";
import AccountModal from "./AccountModal";
// import Avatar from "../../common/Avatar";
import defaultProfileImage from "../../../assets/images/profile/default.webp"; // Default profile image

const Header = ({ title, user, onBurgerClick }) => {
  const profileRef = useRef(null);
  const dispatch = useDispatch();
  // const navigate = useNavigate();

  const [isLogoutClicked, setIsLogoutClicked] = useState(false);
  const [isAccountModalOpen, setIsAccountModalOpen] = useState(false);

  const menuItems = [
    {
      label: "Account Settings",
      icon: <AccountSettingsIcon />,
      action: () => setIsAccountModalOpen(true),
    },
    {
      label: "Log out",
      icon: <LogoutIcon color="#EC2D30" />,
      action: () => setIsLogoutClicked(true),
      color: "#EC2D30",
    },
  ];

  return (
    <header className="header">
      <button
        className="burger-btn"
        onClick={onBurgerClick}
        aria-label="Toggle menu"
      >
        ☰
      </button>
      <div className="header-title">{title}</div>

      {/* Conditionally render the Menu */}
      <Menu
        menuItems={menuItems}
        trigger={
          <div className="header-profile" style={{ cursor: "pointer" }}>
            <img
              src={user.profile_picture || defaultProfileImage}
              alt="User Profile"
              className="profile-image"
            />
            <span className="profile-name">{user.name}</span>
            <span className="down-arrow">
              <DownArrowIcon width={24} height={24} />
            </span>
          </div>
        }
        triggerRef={profileRef}
      />

      {/* Logout Confirmation Modals */}
      {isLogoutClicked && (
        <FullScreenOverlay
          title="Confirm Save"
          width="20%"
          height="20%"
          isPopup={true}
          buttons={[
            { label: "No, Cancel", onClick: () => setIsLogoutClicked(false) },
            {
              label: "Yes, Log out",
              onClick: () => {
                setIsLogoutClicked(false);
                dispatch(logoutAction());
              },
              variant: "danger",
              state: "idle",
            },
          ]}
        >
          <h5 className="semi-bold">Logout?</h5>
          <p className="body-text-regular regular neutral-800">
            Are you sure you want to Log out?
          </p>
        </FullScreenOverlay>
      )}

      {/* Account Modal */}
      {isAccountModalOpen && (
        <AccountModal
          isOpen={isAccountModalOpen}
          user={user}
          onClose={() => setIsAccountModalOpen(false)}
        />
      )}
    </header>
  );
};

export default Header;
